export { PriceCard, PriceCardPsihologiyaIsHigherEducation } from './PriceCard'
export {
  WhatIsIncluded,
  WhatIsIncludedPsihologiyaIsHigherEducation
} from './WhatIsIncluded'
